import { RESET_FORM } from '../actionTypes';
import { creditFileActions } from '../reducer';

export default () => creditFileActions[RESET_FORM]();
